import React, { useEffect, useState } from "react";
import qs from "qs";
import { Navigate, useParams } from "react-router-dom";
import { socketFunc } from "../../../../utils/socketUtil";
import { Toaster } from "../../../../utils/toaster";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import { Spinner } from "react-bootstrap";

const DynamicGames = () => {
  const { provider } = useParams();
  const token = localStorage.getItem("token");
  const socket = socketFunc(token);
  const [iframeUrl, setIframeUrl] = useState("");

  useEffect(() => {
    const decodedParams = decodeURIComponent(window.location.href);
    const parsedValues = qs.parse(decodedParams.split("?")?.[1] || "");
    getLobby(parsedValues);
  }, [provider]);

  const getLobby = (params) => {
    socket.emit(
      "get:sports_lobby",
      {
        providerCode: provider?.toUpperCase(),
        ...params,
      },
      (res) => {
        if (res?.status === "failed") {
          Toaster.Error(res?.message || "Failed to get");
        }
        if (res?.status === "success") {
          handleResponse(res);
        }
      },
    );
  };

  const handleResponse = (value) => {
    if (value?.data && typeof value?.data === "string") {
      setIframeUrl(value?.data);
    } else if (value?.data && "lobbyUrl" in value?.data?.data) {
      setIframeUrl(value?.data?.data?.lobbyUrl);
    } else {
      setIframeUrl("");
    }
  };

  return (
    <div className="live_casino_page live">
      <div className="header-bg">
        <HeaderAfterLogin />
      </div>
      {/* <div className="d-xl-none">
          <LeftBarSports />
        </div> */}
      <div className="gamePageSection">
        {!Boolean(iframeUrl) ? (
          <div className="custom_placeholder_parent">
            <div className="custom_placeholder_child">
              <Spinner animation="grow" variant="primary" size="sm" />
              <Spinner animation="grow" variant="primary" size="sm" />
              <Spinner animation="grow" variant="primary" size="sm" />
            </div>
          </div>
        ) : iframeUrl === "notAllowed" ? (
          <Navigate to="/home" />
        ) : iframeUrl === "notFound" ? (
          <Navigate to="/home" />
        ) : (
          <div className="exchange_iframe">
            <iframe
              title="Exchange"
              src={iframeUrl}
              frameBorder="0"
              // scrolling="no"
              allowFullScreen={true}
            >
              Your browser doesn't support iFrames.
            </iframe>
          </div>
        )}
      </div>

      <div>{/* <BottomNav /> */}</div>
    </div>
  );
};
export default DynamicGames;
